<template>
  <div class="text-center">
    <v-bottom-sheet v-model="sheet" inset>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="error"
          dark
          v-bind="attrs"
          v-on="on"
          class="rounded-pill pulse-animation"
          @click.stop
        >
          <v-icon left>mdi-alert</v-icon> Averías 24/7
        </v-btn>
      </template>
      <v-sheet
        class="text-center rounded-lg"
        height="200px"
        style="left: 10px; top: 50%; transform: translateY(-50%)"
      >
      <v-btn class="mt-6 ml-2" color="error" @click="sheet = !sheet">
            Cerrar
          </v-btn>
        <div class="my-3 font-weight-bold">
          ¡Emergencias sin horario! Estamos aquí para ayudarte las 24 horas, los 7 días de la semana.
        </div>
        <div class="my-3">
          No dudes en contactarnos:
          <v-icon color="primary">mdi-phone</v-icon>
          <v-icon color="green darken-4">mdi-whatsapp</v-icon>
          <a href="tel:+34617870811">617 870 811</a>
        </div>
       
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    sheet: false,
  }),
};
</script>

<style scoped>
.pulse-animation {
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

.rounded-pill {
  border-radius: 50px;
}

.font-weight-bold {
  font-weight: bold;
  font-size: 1.2rem;
  color: #333; /* Puedes ajustar el color según tu preferencia */
}
</style>
